import { render, staticRenderFns } from "./BoxRecords.vue?vue&type=template&id=a3ce8bdc&scoped=true"
import script from "./BoxRecords.vue?vue&type=script&lang=js"
export * from "./BoxRecords.vue?vue&type=script&lang=js"
import style0 from "./BoxRecords.vue?vue&type=style&index=0&id=a3ce8bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ce8bdc",
  null
  
)

export default component.exports